export default __webpack_public_path__ + "static/pantagruel-newsletter-360-abc051ce616a298b0896e748ca462c95.png";